export default "__VITE_ASSET__6c597c6a__"